/**
 * Cleans up a reference by removing the custom prefix and adding the /page/ prefix
 *
 * @param ref - The reference string to clean
 * @param prefix - The custom prefix to remove (e.g., '&')
 * @returns The cleaned reference with /page/ prefix
 */ function cleanRef(ref, prefix) {
    if (!prefix) {
        return ref;
    }
    if (ref.startsWith(prefix)) {
        return `/page/${ref.slice(prefix.length)}`;
    }
    return ref;
}

export { cleanRef };
//# sourceMappingURL=clean-ref.js.map
